export const SITE_DATA_VIEW = "SiteData";
export const USER_DATA_VIEW = "UserData";
